import { View, ScrollView } from "react-native";
import React, { useContext, useEffect, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../Utility/AppScreens";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { getEventId, getLoginData } from "../../../utility/AppStoreData";
import { toast } from "react-toastify";
import { genres } from "../../../Api/configs";
import { ShowLoader } from "../../../common/ShowLoader";
import EventTypeScreen from "../Event/EventTypeScreen";
import SearchFromFriendsModal from "../Event/SearchFromFriendsModal";
import NotificationDetails from "./Notifications/NotificationPopup/NotificationDetails";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import BuyTicketModal from "./Modals/BuyTicketModal";
import Genre from "../../../Components/Genre";
import HomeHeader from "../../../Components/home-common-components/HomeHeader";
import HomeCards from "../../../Components/home-common-components/HomeCards";
import Separator from "../../../Components/Separator";
import CreateEventModal from "../Event/CreateEventModal";
import {
  fetchPopularEvents,
  fetchRecommendedEvents,
  fetchUpcomingEvents,
} from "../../../services/eventsAPI";
import { handleApiError } from "../../../services/errorHandler";
import ChallengeConfirmationModal from "./Notifications/NotificationPopup/ChallengeConfirmationModal";
import { getUserProfile } from "../../../services/authAPI";
import SignUpScreenModal from "../CommonModal/SignUpScreenModal";
import LoginScreenModal from "../CommonModal/LoginScreenModal";
import { AuthContext } from "../../../context/AuthContext";
import EmailVerificationModal from "../CommonModal/EmailVerificationModal";
import Header from "./Common/Header";
import { getEventIdFromURL } from "../../../utility/urlUtils";
import { ScreenBGGradientView } from "../../../common/CommonView";

const HomeWebScreenStatic = ({ route }) => {
  const { path } = route.params || {};
  const { isLoggedIn } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(true);
  const [modalType, setModalType] = useState("signup");
  const navigation = useNavigation();
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [showLoader, setShowLoader] = useState(false);

  const [searchFromFriendsModal, setSearchFromFriendsModal] = useState(false);
  const [arrPopularGeners, arrSetPopularGeners] = useState(genres);
  const [isEmailConfirmationVisible, setIsEmailConfirmationVisible] =
    useState(false);

  const [originalPopularData, setOriginalPopularData] = useState([]);
  // const [popularData, setPopulerData] = useState([]);
  const [popularEmpty, setPopulerEmpty] = useState(false);
  const [originalUpcomingData, setOriginalUpcomingData] = useState([]);
  // const [upComingData, setUpComingData] = useState([]);
  const [upComingEmpty, setUpComingEmpty] = useState(false);
  const [originalRecommendedData, setOriginalRecommendedData] = useState([]);
  // const [recommendedData, setRecommendedData] = useState([]);
  const [recommendedEmpty, setRecommendedEmpty] = useState(false);

  // const [userData, setUserData] = useState(null);
  const [showEventTypeModal, setShowEventTypeModal] = useState(false);
  const [accessToken, setAccessToken] = useState("");

  const [challengeID, setChallengeID] = useState("");
  const [showNotificationDetails, setShowNotificationDetails] = useState(false);

  const [showChallengeConformation, setChallengeConformation] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [isMyEvents, setIsMyEvents] = useState(false);
  // const [isGetTicket, setIsGetTicket] = useState(false);

  const [popularIndex, setPopularIndex] = useState(0);

  const [upcomingIndex, setUpcomingIndex] = useState(0);

  const [recommendedIndex, setRecommendedIndex] = useState(0);
  const [showSignUpScreenModal, setShowSignUpScreenModal] = useState(false);
  const [newUserName, setNewUserName] = useState("");

  // Check for event share URLs and redirect to SignupWebScreen
  useEffect(() => {
    console.log("🏠 HomeWebScreenStatic: Checking for event share URL");
    console.log("📍 Current path param:", path);

    const eventId = getEventIdFromURL(path);
    if (eventId) {
      console.log(
        "✅ Event ID found:",
        eventId,
        "- redirecting to SignupWebScreen"
      );

      // Pass the original event share URL data to SignupWebScreen
      navigation.dispatch(
        StackActions.replace(AppScreens.SignupWebScreen, {
          eventShareURL: path, // Pass the original path with event parameters
          eventId: eventId,
          isFromEventShare: true,
        })
      );
    } else {
      console.log("❌ No event ID found");
    }
  }, [navigation, path]);

  // const [userProfileData, setUserProfileData] = useState(null);
  const popularData = [
    {
      eventID: "d470f6e517de4b77",
      attendeeCount: 3,
      eventPicUrl: "",
      attendeeIDs: ["jacob", "mi", "doyoli"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      createdAt: "2024-09-06T11:39:22.273Z",
      description:
        "The test Description is the new event we have to take care off.Get ready for a gaming event like no other! Join us for \"Brick Battle Royale: LEGO Fortnite Showdown,\" a spectacular streaming event that combines the creativity of LEGO with the excitement of Fortnite in an epic showdown of miniature proportions.🎮 Game Mode: We're bringing the world of Fortnite to life using LEGO bricks! Our talented builders have meticulously recreated iconic Fortnite landscapes, weapons, and characters using LEGO, and now it's time to put them to the test. Watch as players engage in thrilling battles and intense building battles on our custom-made LEGO Fortnite battlegrounds.",
      gamerID: "New1232",
      gameTags: ["Sports"],
      gameTitle: "Rocket League",
      lastModifiedAt: "2024-09-12T12:04:04.618Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      participantIDs: ["mi", "jacob"],
      playType: "Competitive",
      searchTerm: "my new event ",
      startDateTime: "2024-09-20T17:08:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "My new event ",
      type: "Public",
      numberOfAttendees: 3,
    },
    {
      eventID: "5fd36a038b781be7",
      attendeeCount: 2,
      eventPicUrl: "",
      attendeeIDs: ["doyoli", "mi"],
      attendeeDetails: [
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
      ],
      createdAt: "2024-09-11T12:02:01.246Z",
      description:
        "Get ready for a gaming event like no other! Join us for \"Brick Battle Royale: LEGO Fortnite Showdown,\" a spectacular streaming event that combines the creativity of LEGO with the excitement of Fortnite in an epic showdown of miniature proportions.\n\n🎮 Game Mode: We're bringing the world of Fortnite to life using LEGO bricks! Our talented builders have meticulously recreated iconic Fortnite landscapes, weapons, and characters using LEGO, and now it's time to put them to the test. Watch as players engage in thrilling battles and intense building battles on our custom-made LEGO Fortnite battlegrounds.\n\n🎉 Interactive Experience:Engage with our streamers and fellow viewers in real-time through chat, where you can share strategies, cheer for your favorite players, and discuss all things LEGO and Fortnite.\n\nDon't miss out on the most unique streaming event of the year, where two beloved worlds collide in a delightful and action-packed showdown. \"Brick Battle Royale: LEGO Fortnite Showdown\" is an event you won't want to miss. Follow, subscribe, and set your reminders now, and let's get ready to build, battle, and conquer!\n",
      gamerID: "Game789",
      gameTags: ["Sports"],
      gameTitle: "College Football Revamped",
      lastModifiedAt: "2024-09-13T06:31:39.118Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
      ],
      participantIDs: ["mi"],
      playType: "Competitive",
      searchTerm: "the new event",
      startDateTime: "2024-09-13T17:30:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "The new Event",
      type: "Public",
      numberOfAttendees: 2,
    },
    {
      eventID: "a2fc91b81b6b86f36",
      attendeeCount: 4,
      eventPicUrl: "",
      attendeeIDs: ["jacob", "mi", "doyoli"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off ",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-12T12:08:24.426Z",
      minimumAttendees: 25,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Upcoming",
      ticketPrice: "5",
      title: "New Event ",
      type: "Private",
      numberOfAttendees: 3,
    },
    {
      eventID: "cdscsdcds123",
      attendeeCount: 4,
      eventPicUrl: "",
      attendeeIDs: ["jacob", "mi", "doyoli"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off ",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-12T12:17:19.221Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Ongoing",
      ticketPrice: null,
      title: "New Event ",
      type: "Public",
      numberOfAttendees: 3,
    },
    {
      eventID: "137b57937a0e7767",
      attendeeCount: 1,
      eventPicUrl: "",
      attendeeIDs: ["mi"],
      attendeeDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
      ],
      createdAt: "2024-09-12T09:22:26.274Z",
      description:
        'Get ready for a gaming event like no other! Join us for "Brick Battle Royale: LEGO Fortnite Showdown," a spectacular streaming event that combines the creativity of LEGO with the excitement of Fortnite in an epic showdown of miniature proportions.',
      gamerID: "789",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-13T08:08:14.408Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      participantIDs: ["mi", "jacob"],
      playType: "Competitive",
      searchTerm: "play fortnite",
      startDateTime: "2024-09-16T14:51:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "Play Fortnite",
      type: "Public",
      numberOfAttendees: 1,
    },
    {
      eventID: "a2fc91b81b6b86f2345",
      attendeeCount: 1,
      eventPicUrl: "",
      attendeeIDs: ["jacob"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off.Get ready for a gaming event like no other! Join us for \"Brick Battle Royale: LEGO Fortnite Showdown,\" a spectacular streaming event that combines the creativity of LEGO with the excitement of Fortnite in an epic showdown of miniature proportions.🎮 Game Mode: We're bringing the world of Fortnite to life using LEGO bricks! Our talented builders have meticulously recreated iconic Fortnite landscapes, weapons, and characters using LEGO, and now it's time to put them to the test. Watch as players engage in thrilling battles and intense building battles on our custom-made LEGO Fortnite battlegrounds.",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-12T11:43:13.263Z",
      minimumAttendees: 25,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Upcoming",
      ticketPrice: "5",
      title: "New Event ",
      type: "Private",
      numberOfAttendees: 1,
    },
    {
      eventID: "a2fc91b81b6b86f45",
      attendeeCount: 1,
      eventPicUrl: "",
      attendeeIDs: ["doyoli"],
      attendeeDetails: [
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off ",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-12T12:16:18.916Z",
      minimumAttendees: 25,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Upcoming",
      ticketPrice: "100",
      title: "New Event ",
      type: "Private",
      numberOfAttendees: 1,
    },
    {
      eventID: "a4fc5b1b1b3a87a8",
      attendeeCount: 1,
      eventPicUrl:
        "https://squdifi-event-thumbnail.s3.eu-west-2.amazonaws.com/8bQ3dN-thumbnail-image.jpg",
      attendeeIDs: ["jacob"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      createdAt: "2024-09-11T05:35:16.541Z",
      description: "The new private event",
      gamerID: "mi",
      gameTags: ["General"],
      gameTitle: "Fangs",
      lastModifiedAt: "2024-09-12T11:57:02.523Z",
      minimumAttendees: 30,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "the new private event",
      startDateTime: "2024-09-13T11:56:00.000Z",
      status: "Upcoming",
      ticketPrice: "50",
      title: "The new private event",
      type: "Private",
      numberOfAttendees: 1,
    },
    {
      eventID: "fead67f05e849f16",
      attendeeCount: 1,
      eventPicUrl:
        "https://squdifi-event-thumbnail.s3.eu-west-2.amazonaws.com/5yY67J-HWPH.png",
      attendeeIDs: ["mi"],
      attendeeDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
      ],
      createdAt: "2024-09-13T08:05:24.530Z",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has surLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. \n\nIt was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. \n\n\nLorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.vived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      gamerID: "23erwer",
      gameTags: ["Action", "Shooter"],
      gameTitle: "Diabotical",
      lastModifiedAt: "2024-09-16T05:53:09.187Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
      ],
      participantIDs: ["mi"],
      playType: "Competitive",
      searchTerm: "test event",
      startDateTime: "2024-09-16T15:39:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "Test event",
      type: "Public",
      numberOfAttendees: 1,
    },
    {
      eventID: "2581b3c8887c9808",
      attendeeCount: null,
      eventPicUrl: "",
      attendeeIDs: [],
      attendeeDetails: [],
      createdAt: "2024-09-11T13:00:55.824Z",
      description: "Tetsing new streaming",
      gamerID: "134",
      gameTags: ["Sports"],
      gameTitle: "Rocket League",
      lastModifiedAt: "2024-09-11T13:00:55.824Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      participantIDs: ["mi", "jacob"],
      playType: "Competitive",
      searchTerm: "new streaming",
      startDateTime: "2024-09-25T18:30:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "New streaming",
      type: "Public",
      numberOfAttendees: 0,
    },
  ];
  const upComingData = [
    {
      eventID: "137b57937a0e7767",
      eventPicUrl: "",
      attendeeIDs: ["mi"],
      attendeeDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
      ],
      createdAt: "2024-09-12T09:22:26.274Z",
      description:
        'Get ready for a gaming event like no other! Join us for "Brick Battle Royale: LEGO Fortnite Showdown," a spectacular streaming event that combines the creativity of LEGO with the excitement of Fortnite in an epic showdown of miniature proportions.',
      gamerID: "789",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-13T08:08:14.408Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      participantIDs: ["mi", "jacob"],
      playType: "Competitive",
      searchTerm: "play fortnite",
      startDateTime: "2024-09-16T14:51:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "Play Fortnite",
      type: "Public",
      numberOfAttendees: 1,
    },
    {
      eventID: "fead67f05e849f16",
      eventPicUrl:
        "https://squdifi-event-thumbnail.s3.eu-west-2.amazonaws.com/5yY67J-HWPH.png",
      attendeeIDs: ["mi"],
      attendeeDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
      ],
      createdAt: "2024-09-13T08:05:24.530Z",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has surLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. \n\nIt was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. \n\n\nLorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.vived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      gamerID: "23erwer",
      gameTags: ["Action", "Shooter"],
      gameTitle: "Diabotical",
      lastModifiedAt: "2024-09-16T05:53:09.187Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
      ],
      participantIDs: ["mi"],
      playType: "Competitive",
      searchTerm: "test event",
      startDateTime: "2024-09-16T15:39:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "Test event",
      type: "Public",
      numberOfAttendees: 1,
    },
    {
      eventID: "48c8e2a7d93594cb",
      eventPicUrl: "",
      attendeeIDs: [],
      attendeeDetails: [],
      createdAt: "2024-09-13T11:08:23.940Z",
      description: "Demo Description",
      gamerID: "Test123",
      gameTags: ["Sports"],
      gameTitle: "Rocket League",
      lastModifiedAt: "2024-09-13T11:08:23.940Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
      ],
      participantIDs: ["mi"],
      playType: "Competitive",
      searchTerm: "test notificaiton event",
      startDateTime: "2024-09-20T16:36:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "Test Notificaiton Event",
      type: "Public",
      numberOfAttendees: 0,
    },
    {
      eventID: "d470f6e517de4b77",
      eventPicUrl: "",
      attendeeIDs: ["jacob", "mi", "doyoli"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      createdAt: "2024-09-06T11:39:22.273Z",
      description:
        "The test Description is the new event we have to take care off.Get ready for a gaming event like no other! Join us for \"Brick Battle Royale: LEGO Fortnite Showdown,\" a spectacular streaming event that combines the creativity of LEGO with the excitement of Fortnite in an epic showdown of miniature proportions.🎮 Game Mode: We're bringing the world of Fortnite to life using LEGO bricks! Our talented builders have meticulously recreated iconic Fortnite landscapes, weapons, and characters using LEGO, and now it's time to put them to the test. Watch as players engage in thrilling battles and intense building battles on our custom-made LEGO Fortnite battlegrounds.",
      gamerID: "New1232",
      gameTags: ["Sports"],
      gameTitle: "Rocket League",
      lastModifiedAt: "2024-09-12T12:04:04.618Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      participantIDs: ["mi", "jacob"],
      playType: "Competitive",
      searchTerm: "my new event ",
      startDateTime: "2024-09-20T17:08:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "My new event ",
      type: "Public",
      numberOfAttendees: 3,
    },
    {
      eventID: "a2fc91b81b6b86f45",
      eventPicUrl: "",
      attendeeIDs: ["doyoli"],
      attendeeDetails: [
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off ",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-12T12:16:18.916Z",
      minimumAttendees: "25",
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "New Event ",
      type: "Private",
      numberOfAttendees: 1,
    },
    {
      eventID: "cdscsdcds123",
      eventPicUrl: "",
      attendeeIDs: ["jacob", "mi", "doyoli"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off ",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-12T12:17:19.221Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Ongoing",
      ticketPrice: null,
      title: "New Event ",
      type: "Public",
      numberOfAttendees: 3,
    },
    {
      eventID: "a2fc91b81b6b86f3",
      eventPicUrl: "",
      attendeeIDs: ["jacob", "jacob", "jacob", "jacob", "jacob"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off ",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-09T07:59:31.651Z",
      minimumAttendees: "25",
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "New Event ",
      type: "Private",
      numberOfAttendees: 5,
    },
    {
      eventID: "a2fc91b81b6b86f378",
      eventPicUrl: "",
      attendeeIDs: [],
      attendeeDetails: [],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off ",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-09T07:59:31.651Z",
      minimumAttendees: "25",
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "New Event ",
      type: "Private",
      numberOfAttendees: 0,
    },
    {
      eventID: "a2fc91b81b6b86f36",
      eventPicUrl: "",
      attendeeIDs: ["jacob", "mi", "doyoli"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off ",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-12T12:08:24.426Z",
      minimumAttendees: "25",
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "New Event ",
      type: "Private",
      numberOfAttendees: 3,
    },
    {
      eventID: "a2fc91b81b6b86f345",
      eventPicUrl: "",
      attendeeIDs: [],
      attendeeDetails: [],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off ",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-09T07:59:31.651Z",
      minimumAttendees: "25",
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "New Event ",
      type: "Private",
      numberOfAttendees: 0,
    },
    {
      eventID: "a2fc91b81b6b86f2345",
      eventPicUrl: "",
      attendeeIDs: ["jacob"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      createdAt: "2024-09-09T07:59:31.651Z",
      description:
        "The test Description is the new event we have to take care off.Get ready for a gaming event like no other! Join us for \"Brick Battle Royale: LEGO Fortnite Showdown,\" a spectacular streaming event that combines the creativity of LEGO with the excitement of Fortnite in an epic showdown of miniature proportions.🎮 Game Mode: We're bringing the world of Fortnite to life using LEGO bricks! Our talented builders have meticulously recreated iconic Fortnite landscapes, weapons, and characters using LEGO, and now it's time to put them to the test. Watch as players engage in thrilling battles and intense building battles on our custom-made LEGO Fortnite battlegrounds.",
      gamerID: "New ID",
      gameTags: ["Action", "Shooter", "Battle Royale"],
      gameTitle: "Fortnite",
      lastModifiedAt: "2024-09-12T11:43:13.263Z",
      minimumAttendees: "25",
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "new event ",
      startDateTime: "2024-09-25T13:27:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "New Event ",
      type: "Private",
      numberOfAttendees: 1,
    },
    {
      eventID: "2581b3c8887c9808",
      eventPicUrl: "",
      attendeeIDs: [],
      attendeeDetails: [],
      createdAt: "2024-09-11T13:00:55.824Z",
      description: "Tetsing new streaming",
      gamerID: "134",
      gameTags: ["Sports"],
      gameTitle: "Rocket League",
      lastModifiedAt: "2024-09-11T13:00:55.824Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      participantIDs: ["mi", "jacob"],
      playType: "Competitive",
      searchTerm: "new streaming",
      startDateTime: "2024-09-25T18:30:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "New streaming",
      type: "Public",
      numberOfAttendees: 0,
    },
    {
      eventID: "79c2fc4225349397",
      eventPicUrl: "",
      attendeeIDs: [],
      attendeeDetails: [],
      createdAt: "2024-09-11T13:09:09.238Z",
      description: "Test",
      gamerID: "Bew3",
      gameTags: ["General"],
      gameTitle: "Reign of Titans",
      lastModifiedAt: "2024-09-11T13:09:09.238Z",
      minimumAttendees: null,
      organiserID: "jacob",
      participantDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
      ],
      participantIDs: ["jacob"],
      playType: "Competitive",
      searchTerm: "new ticket",
      startDateTime: "2024-09-26T18:38:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "New ticket",
      type: "Public",
      numberOfAttendees: 0,
    },
    {
      eventID: "cbf77ceb852aaeb7",
      eventPicUrl:
        "https://squdifi-event-thumbnail.s3.eu-west-2.amazonaws.com/EW94Kc-image.png",
      attendeeIDs: [],
      attendeeDetails: [],
      createdAt: "2024-09-13T11:09:59.539Z",
      description: "New ",
      gamerID: "Test123",
      gameTags: ["General"],
      gameTitle: "Fangs",
      lastModifiedAt: "2024-09-13T11:09:59.539Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
      ],
      participantIDs: ["mi"],
      playType: "Competitive",
      searchTerm: "newsocket",
      startDateTime: "2024-09-27T16:39:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "NewSocket",
      type: "Public",
      numberOfAttendees: 0,
    },
    {
      eventID: "491d3aef2f10712b",
      eventPicUrl: "",
      attendeeIDs: ["jacob", "mi", "doyoli", "jacob", "doyoli"],
      attendeeDetails: [
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
        {
          firstName: "Jacob",
          profilePicture: "",
          userID: "jacob",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      createdAt: "2024-09-06T11:40:48.872Z",
      description: "these description",
      gamerID: "New234",
      gameTags: ["Sports"],
      gameTitle: "Rocket League",
      lastModifiedAt: "2024-09-06T11:40:48.872Z",
      minimumAttendees: null,
      organiserID: "mi",
      participantDetails: [
        {
          firstName: "mil",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/mi-profile-pic.jpg",
          userID: "mi",
        },
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["mi", "doyoli"],
      playType: "Competitive",
      searchTerm: "feat ",
      startDateTime: "2024-09-27T17:10:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "feat ",
      type: "Public",
      numberOfAttendees: 5,
    },
    {
      eventID: "88eaf202a0e3106f",
      eventPicUrl: "",
      attendeeIDs: [],
      attendeeDetails: [],
      createdAt: "2024-09-12T12:46:46.083Z",
      description:
        "The Game should be the Event Game and it is For testing Purpose",
      gamerID: "Test123",
      gameTags: ["General"],
      gameTitle: "Shuffleboard",
      lastModifiedAt: "2024-09-12T12:50:09.765Z",
      minimumAttendees: null,
      organiserID: "doyoli",
      participantDetails: [
        {
          firstName: "Dev",
          profilePicture:
            "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
          userID: "doyoli",
        },
      ],
      participantIDs: ["doyoli"],
      playType: "Competitive",
      searchTerm: "gamer pro",
      startDateTime: "2024-09-28T18:15:00Z",
      status: "Upcoming",
      ticketPrice: null,
      title: "Gamer Pro",
      type: "Public",
      numberOfAttendees: 0,
    },
  ];
  const recommendedData = [];
  const userData = {
    message: "Login successful",
    username: "doyoli",
    IdToken:
      "eyJraWQiOiJkR2RYdHo3NEZLZXFiSUptbUtQKzBHSFpqNGFjUFRqdFZmTHE5bVU1R1Q0PSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiIxMDIyMWFjNi1mNTEzLTQwYWUtODM5Mi1lODA3M2U4ZmI1ZTYiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLmV1LXdlc3QtMi5hbWF6b25hd3MuY29tXC9ldS13ZXN0LTJfNnk1TkVOcGZLIiwiY29nbml0bzp1c2VybmFtZSI6ImRveW9saSIsImdpdmVuX25hbWUiOiJEZXYiLCJvcmlnaW5fanRpIjoiYjI1MzBlYWEtZWVkYy00ZjdiLWFiYTctNzI5ZmFlMzI5MmY4IiwiYXVkIjoiMjkwZnU1bzE1bjU0cmc0MDdidDdoY29xcXUiLCJldmVudF9pZCI6ImRmMjhlNWI0LTMwNjgtNDk3YS04NjdhLTVmMTFhMWE4OWZiZSIsInRva2VuX3VzZSI6ImlkIiwiYXV0aF90aW1lIjoxNzI2NDY4MzYwLCJleHAiOjE3MjY1NTQ3NjAsImlhdCI6MTcyNjQ2ODM2MCwiZmFtaWx5X25hbWUiOiJEZWx2YWRpYSIsImp0aSI6ImQyYzIwNjljLThiNTMtNDBmMC04OTZhLWVkOWRhYjI4ZjE2MyIsImVtYWlsIjoiZG95b2xpMjU1MEBjb2xvcnV6LmNvbSJ9.V88J8CemLAQMA9Pahw-6krXUJwcPnj7zohHc5DlyHLIbag6L6iEMI3-B7kUywOsGG27aHExYIq1p7Rs0hykAOS5EPs-1OIavRenu46OUpJw7v3ny7sHlV_TfKbUJtLHEoBHgXu0EEZSlu4eJjtX7IhG5CEX3AITn1AuIWFf-w577LoC-G_14UfqCRCvT7LQW5eRHCZbGTpQkZghvMBPtC7mdHnXWRjSwSN31k_xXC_-4IBcOyBTP5DUbP7cvsdpcbLrVBY1ZlgXLhLEKfSOVx7qI5k4tGuEKAYlB-lGIQX4loOoOMIBPRtmeiSLmKiA8Jt_w3LiuvxddDYJrqR88-w",
    idTokenExpiresIn: 86400,
    AccessToken:
      "eyJraWQiOiJkREdscUthM0dtSUx2MGJtS1lpZDB4RFVTMGhCdFwvZXBZWkNMWDI1ZEFKYz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIxMDIyMWFjNi1mNTEzLTQwYWUtODM5Mi1lODA3M2U4ZmI1ZTYiLCJkZXZpY2Vfa2V5IjoiZXUtd2VzdC0yXzhkM2YyZGMyLWNhNmMtNGI0NC04ZDk4LTMzYWM5NGNkNzkxNCIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC5ldS13ZXN0LTIuYW1hem9uYXdzLmNvbVwvZXUtd2VzdC0yXzZ5NU5FTnBmSyIsImNsaWVudF9pZCI6IjI5MGZ1NW8xNW41NHJnNDA3YnQ3aGNvcXF1Iiwib3JpZ2luX2p0aSI6ImIyNTMwZWFhLWVlZGMtNGY3Yi1hYmE3LTcyOWZhZTMyOTJmOCIsImV2ZW50X2lkIjoiZGYyOGU1YjQtMzA2OC00OTdhLTg2N2EtNWYxMWExYTg5ZmJlIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTcyNjQ2ODM2MCwiZXhwIjoxNzI2NTU0NzYwLCJpYXQiOjE3MjY0NjgzNjAsImp0aSI6IjQwNTM2Y2MyLTYyM2ItNDMwYi04ZDBhLWI0Mzg4ZTNhM2Q4MSIsInVzZXJuYW1lIjoiZG95b2xpIn0.etEDG8YjuNKlR4a1Kkf-EftGVSYUkdhmwYmpr-6FGY6FABWo8lXf-_FpyFUP6G14s5tK0Yv2GlGQ4Zy2vyhd_mqh_9gluZ3W0jN0ClG9pdjGN2YVFtHwoNRxN6-6SkDZIlizRACKxbrnCNVfwGq5aBUZeHgxyJDI9vSV78eScf0p1w4Si4MQQUifTagam-pYBv21tMwzeiyZZL4ywIDsBssfcJk9qqrLTkHLRWEs-Sg9qv15dSQZBhEVg7JR873XSrPI70MTT6LOL4A8wSzrLvLgT11UYCbCmqBovnrOVkCSFY6oR9ZvuQ62qyMyysqKri91EMA79OEm8GixDUYMTw",
    accessTokenExpiresIn: 86400,
  };
  // useEffect(() => {
  //   getLoginUserData();
  //   getEventPopuler();
  //   getUpComingEvent();
  // }, []);
  const userProfileData = {
    userID: "doyoli",
    email: "doyoli2550@coloruz.com",
    firstName: "Dev",
    lastName: "Delvadia",
    language: "asdasdf",
    timeZone: "(+05:30) Kolkata",
    bio: "",
    profilePicture:
      "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/doyoli-profile-pic.jpg",
    country: "India",
    emailPrivateMessage: false,
    emailBattleNotification: true,
    readOnChallenge: false,
    occasionalEmail: true,
    blockedUsers: [],
    events: [
      {
        gameTitle: "Shuffleboard",
        eventID: "88eaf202a0e3106f",
        userID: "doyoli",
        ticketID: "",
        eventDate: "2024-09-28T18:15:00Z",
        createdAt: "2024-09-12T12:46:46.261Z",
        gameTags: ["General"],
        type: "Participant",
      },
      {
        eventID: "a4fc5b1b1b3a87a8",
        gameTags: ["General"],
        eventDate: "2024-09-13T11:56:00.000Z",
        userID: "doyoli",
      },
      {
        eventID: "afnjkk34y8923",
        gameTags: ["Action", "Shooter", "Battle Royale"],
        eventDate: "2024-09-14T11:40:00.000Z",
        userID: "doyoli",
      },
    ],
    belts: {
      bronze: 4,
      silver: 0,
      gold: 0,
      platinum: 0,
    },
    myGames: ["Roblox", "Blobby Volley 2"],
    selectedGames: {
      "Other Miscellaneous": ["Roblox", "Blobby Volley 2"],
    },
    playedGames: [
      {
        gameTitle: "The new Event",
      },
      {
        eventId: "88eaf202a0e3106f",
        gameTitle: "Shuffleboard",
      },
    ],
    organised: [
      {
        eventId: "88eaf202a0e3106f",
        gameTitle: "Shuffleboard",
      },
    ],
    challenged: [
      {
        gameTitle: "The new Event",
      },
    ],
    gamesWon: [],
    gameLost: [],
    tokens: 4405,
    coins: 0,
    balance: 0,
    credits: 0,
    wonBelts: 0,
    lostBelts: 0,
    ticketsSold: 0,
  };
  const filterEventsByTag = (tag: string, id: number) => {
    const updatedGenres = arrPopularGeners.map((genre) =>
      genre.id === id
        ? { ...genre, isSelected: 1 }
        : { ...genre, isSelected: 0 }
    );
    arrSetPopularGeners(updatedGenres);

    const filteredPopularData = originalPopularData.filter((event) =>
      event.gameTags.includes(tag)
    );

    const filteredUpcomingData = originalUpcomingData.filter((event) =>
      event.gameTags.includes(tag)
    );
    // setUpComingData(filteredUpcomingData);

    const filteredRecommendedData = originalRecommendedData.filter((event) =>
      event.gameTags.includes(tag)
    );
    // setRecommendedData(filteredRecommendedData);
  };

  // const urlStart = "https://nextgenaisolutions.ai/Notificationssssss?ID=sdsadadasad";

  // const copyToClipboard = async () => {
  //     try {
  //         const linkToCopy = urlStart + challengeID;
  //         await Clipboard.setStringAsync(linkToCopy);
  //         const text = await Clipboard.getStringAsync();
  //         toast.success("Link copied to clipboard");
  //     } catch (error) {
  //         console.log("linkToCopy============error:- ", error);
  //     }
  // };

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      {/* Mobile Device navigation Header */}
      {/* {(deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS) && (
        <MobileDeviceNavigationHeader
          createEventTapped={() => {
            setShowEventTypeModal(true);
          }}
          btnNotificationTapped={() => {
            navigateToScreen(navigation, AppScreens.NotificationScreen
                // { txtSearch: searchEvent });
          }}
          btnSettingTapped={() => {
            navigateToScreen(navigation, AppScreens.SettingWebScreen
                // { txtSearch: searchEvent });
          }}
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen
                // { txtSearch: searchEvent });
          }}
        />
      )} */}
      {/* <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      /> */}

      <View style={[styles.container, {}]}>
        {!isLoggedIn && modalType === "signup" && (
          <SignUpScreenModal
            route={route}
            showModal={showModal}
            setShowModal={setShowModal}
            setModalType={setModalType}
            setIsEmailConfirmationVisible={setIsEmailConfirmationVisible}
            path={path}
            newUserName={newUserName}
            setNewUserName={setNewUserName}
          />
        )}
        {!isLoggedIn && modalType === "login" && (
          <LoginScreenModal
            showModal={showModal}
            setShowModal={setShowModal}
            setModalType={setModalType}
            path={path}
          />
        )}
        {isEmailConfirmationVisible && (
          <EmailVerificationModal
            showModal={isEmailConfirmationVisible}
            setShowModal={setIsEmailConfirmationVisible}
            username={newUserName}
            setSignUpShowModel={setShowModal}
            path={path}
          />
        )}
        <HomeHeader
          userData={userData}
          isMyEvents={isMyEvents}
          setIsMyEvents={setIsMyEvents}
          setShowEventTypeModal={setShowEventTypeModal}
        />

        {/* Separater */}
        <Separator
          color={AppColors.appGrayColor_1C1C1C}
          height={2}
          marginTop={0}
          marginBottom={0}
          marginHorizontal={0}
        />

        {/* Popular Genres */}
        <Genre
          heading="Popular Genres"
          filterEventsByTag={filterEventsByTag}
          arrPopularGeners={arrPopularGeners}
        />

        {/* Separater */}
        <Separator
          color={AppColors.appGrayColor_1C1C1C}
          height={2}
          marginTop={0}
          marginBottom={0}
          marginHorizontal={0}
        />

        <ScrollView
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
        >
          {/* Popular Events  */}
          {userProfileData && (
            <HomeCards
              userData={userData}
              heading="Popular Events"
              CardData={popularData}
              CardDataEmpty={popularEmpty}
              // setIsGetTicket={setIsGetTicket}
              accessToken={accessToken}
              popularIndex={popularIndex}
              setPopularIndex={setPopularIndex}
              userProfileData={userProfileData}
            />
          )}

          {/* Separater */}
          <Separator
            color={AppColors.appGrayColor_1C1C1C}
            height={2}
            marginTop={0}
            marginBottom={0}
            marginHorizontal={0}
          />

          {/* Upcoming */}
          {userProfileData && (
            <HomeCards
              userData={userData}
              heading="Upcoming"
              CardData={upComingData}
              CardDataEmpty={upComingEmpty}
              // setIsGetTicket={setIsGetTicket}
              accessToken={accessToken}
              popularIndex={upcomingIndex}
              setPopularIndex={setUpcomingIndex}
              userProfileData={userProfileData}
            />
          )}

          {/* Separater */}
          <Separator
            color={AppColors.appGrayColor_1C1C1C}
            height={2}
            marginTop={0}
            marginBottom={0}
            marginHorizontal={0}
          />

          {/* Recommended */}
          {userProfileData && (
            <HomeCards
              userData={userData}
              heading="Recommended"
              CardData={recommendedData}
              CardDataEmpty={recommendedEmpty}
              // setIsGetTicket={setIsGetTicket}
              accessToken={accessToken}
              popularIndex={recommendedIndex}
              setPopularIndex={setRecommendedIndex}
              userProfileData={userProfileData}
            />
          )}

          {/* Separater */}
          <Separator
            color={AppColors.appGrayColor_1C1C1C}
            height={2}
            marginTop={0}
            marginBottom={0}
            marginHorizontal={0}
          />
        </ScrollView>

        {<ShowLoader showIndicater={showLoader} />}
        {showNotificationDetails && (
          <NotificationDetails
            showModal={showNotificationDetails}
            setShowModal={setShowNotificationDetails}
            challengeID={challengeID}
            username={userData && userData.username}
            setIsAccepted={null}
            accessToken={accessToken}
            onAcceptPress={(isAccepted) => {
              setIsAccepted(isAccepted);
              setChallengeConformation(true);
            }}
          />
        )}

        {showChallengeConformation && (
          <ChallengeConfirmationModal
            showModal={showChallengeConformation}
            setShowModal={setChallengeConformation}
            isAccepted={isAccepted}
            accessToken={accessToken}
            challengeID={challengeID}
            onConfirmPress={(isAccepted) => {}}
          />
        )}

        {searchFromFriendsModal && (
          <SearchFromFriendsModal
            showModal={searchFromFriendsModal}
            setShowModal={setSearchFromFriendsModal}
          />
        )}
        {showEventTypeModal && (
          <EventTypeScreen
            showModal={showEventTypeModal}
            setShowModal={setShowEventTypeModal}
          />
        )}

        {/* {isGetTicket && (
          <BuyTicketModal
            closeButTicket={() => {
              setIsGetTicket(false);
            }}
          />
        )} */}
      </View>
      {isMyEvents && (
        <CreateEventModal
          showModal={isMyEvents}
          setShowModal={setIsMyEvents}
          setShowEventTypeModal={setShowEventTypeModal}
        />
      )}
    </View>
  );

  // async function getLoginUserData() {
  //   const data = await getLoginData();

  //   if (data != null) {
  //     setUserData(data);

  //     getRecommendedEvent(data.username != null ? data.username : "");
  //     if (data.AccessToken) {
  //       setAccessToken(data.AccessToken);
  //       userProfileAPI(data.AccessToken);
  //       getEventId().then((eventId) => {
  //         if (eventId != "" && eventId != null && eventId != undefined) {
  //           setChallengeID(eventId);
  //           setShowNotificationDetails(true);
  //         }
  //       });
  //     }
  //   }
  // }
};

export default HomeWebScreenStatic;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    searchTextStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: 459,
      height: 35,
      alignItems: "center",
      borderWidth: 0,
    },
    listBgViewStyle: {
      width: 220,
      gap: 5,
    },
    attendeesBgViewStyle: {
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 7,
      alignSelf: "flex-start",
    },
    btnLeftStyle: {
      height: 80,
      width: 25,
      backgroundColor: AppColors.white,
      left: 0,
      top: 25,
    },
    btnRightStyle: {
      height: 80,
      width: 25,
      backgroundColor: AppColors.white,
      right: 0,
      top: 25,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 459,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        width: 220,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnLeftStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        left: 0,
        top: 25,
      },
      btnRightStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        right: 0,
        top: 25,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 459,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        width: 220,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnLeftStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        left: 0,
        top: 25,
      },
      btnRightStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        right: 0,
        top: 25,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 459,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        width: 220,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnLeftStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        left: 0,
        top: 25,
      },
      btnRightStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        right: 0,
        top: 25,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 600,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        width: 185,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnLeftStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        left: 0,
        top: 25,
      },
      btnRightStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        right: 0,
        top: 25,
      },
    },
  }
);
